import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import addClassCss from './index.scss';
import AddClassForm from './add-class-form';
import AddClassConfirmation from './confirmation';
import withModal from '../with-modal';

const AddClass = (props) => {
    const {
        showAddClassConfirmationModal
    } = props;
    let content = (<AddClassForm {...props} />);

    content = showAddClassConfirmationModal ?
        (<AddClassConfirmation {...props} />) :
        content;

    return (content);
};

AddClass.propTypes = {
    showAddClassConfirmationModal: PropTypes.bool
};

const StyledAddClass = styleable(addClassCss)(AddClass);

export default withModal('isActive')(StyledAddClass);



// WEBPACK FOOTER //
// ./app/components/add-class/index.js